import { Children, cloneElement, memo, useCallback, useMemo, } from 'react';
import { useMintedField } from '../useMintedField/useMintedField';
const MintedCreditCardInputField = ({ children, }) => {
    const cardNumberProps = useMintedField({
        name: 'cardnumber',
    });
    const expirationDateProps = useMintedField({
        name: 'cc-exp',
    });
    const cvcProps = useMintedField({
        name: 'cvc',
    });
    const onBlur = useCallback((event) => {
        cardNumberProps.onBlur(event);
        expirationDateProps.onBlur(event);
        cvcProps.onBlur(event);
    }, [
        cardNumberProps,
        expirationDateProps,
        cvcProps,
    ]);
    const onChange = useCallback((event) => {
        if (event.target.name === cardNumberProps.name) {
            cardNumberProps.onChange(event);
        }
        else if (event.target.name === expirationDateProps.name) {
            expirationDateProps.onChange(event);
        }
        else if (event.target.name === cvcProps.name) {
            cvcProps.onChange(event);
        }
    }, [
        cardNumberProps,
        expirationDateProps,
        cvcProps,
    ]);
    const childProps = (useMemo(() => ({
        cardNumberProps: {
            // disabled: cardNumberProps.disabled,
            error: cardNumberProps.error,
            name: cardNumberProps.name,
            touched: cardNumberProps.touched,
            value: cardNumberProps.value,
        },
        cvvProps: {
            // disabled: cvcProps.disabled,
            error: cvcProps.error,
            name: cvcProps.name,
            touched: cvcProps.touched,
            value: cvcProps.value,
        },
        expDateProps: {
            // disabled: expirationDateProps.disabled,
            error: expirationDateProps.error,
            name: expirationDateProps.name,
            touched: expirationDateProps.touched,
            value: expirationDateProps.value,
        },
        onBlur,
        onChange,
    }), [
        cardNumberProps,
        expirationDateProps,
        cvcProps,
        onBlur,
        onChange,
    ]));
    return (cloneElement((Children
        .only(children)), childProps));
};
const MemoizedMintedCreditCardInputField = memo(MintedCreditCardInputField);
export { MemoizedMintedCreditCardInputField as MintedCreditCardInputField };
// MC-1068 Temporary hack for Storybook.
export default MintedCreditCardInputField;
